import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(10000);
const savedMinimalSchema = z.string().max(10000);
const schema = z.string().min(1).max(10000);
const savedSchema = z.string().min(1).max(10000);
const jsonSchema = z.string();
/**
 * 分担機関役割(値オブジェクト)のメタデータ。
 *
 *  */
export const collaborativePartnerRoleMeta = new ValueObjectMetaString(
  "CollaborativePartnerRole",
  "\u5206\u62C5\u6A5F\u95A2\u5F79\u5272",
  messageId("lbl.\u5206\u62C5\u6A5F\u95A2\u5F79\u5272"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
